export interface Suits {
  s1: number;
  s2: number;
}

export const IndexSuitMap: Record<number, Suits> = {
  0: { s1: 0, s2: 0 },
  1: { s1: 1, s2: 0 },
  2: { s1: 1, s2: 1 },
  3: { s1: 2, s2: 0 },
  4: { s1: 2, s2: 1 },
  5: { s1: 2, s2: 2 },
  6: { s1: 3, s2: 0 },
  7: { s1: 3, s2: 1 },
  8: { s1: 3, s2: 2 },
  9: { s1: 3, s2: 3 },
  10: { s1: 4, s2: 0 },
  11: { s1: 4, s2: 1 },
  12: { s1: 4, s2: 2 },
  13: { s1: 4, s2: 3 },
  14: { s1: 4, s2: 4 },
  15: { s1: 5, s2: 0 },
  16: { s1: 5, s2: 1 },
  17: { s1: 5, s2: 2 },
  18: { s1: 5, s2: 3 },
  19: { s1: 5, s2: 4 },
  20: { s1: 5, s2: 5 },
  21: { s1: 6, s2: 0 },
  22: { s1: 6, s2: 1 },
  23: { s1: 6, s2: 2 },
  24: { s1: 6, s2: 3 },
  25: { s1: 6, s2: 4 },
  26: { s1: 6, s2: 5 },
  27: { s1: 6, s2: 6 },
};

export function getSuits(card: number): [number, number] {
  const s = IndexSuitMap[card];
  if (!s) return [0, 0];
  return [s.s1, s.s2];
}

export function isDouble(card: number): boolean {
  const s = IndexSuitMap[card];
  if (!s) return false;
  return s.s1 === s.s2;
}

export function pipCount(card: number): number {
  const [a, b] = getSuits(card);
  return a + b;
}

export function assetPathFor(card: number): string {
  return `/static/dominos/${card}.png`;
}
